'use client';

import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "align", "sideOffset", "removePadding", "removePortal"];
import * as React from 'react';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import { cn } from "../utils";
import { jsx as _jsx } from "react/jsx-runtime";
var Popper = PopoverPrimitive.Root;
var PopperTrigger = PopoverPrimitive.Trigger;
var PopperAnchor = PopoverPrimitive.Anchor;
var PopperClose = PopoverPrimitive.Close;
var PopperContent = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'center' : _ref$align,
    _ref$sideOffset = _ref.sideOffset,
    sideOffset = _ref$sideOffset === void 0 ? 4 : _ref$sideOffset,
    removePadding = _ref.removePadding,
    removePortal = _ref.removePortal,
    props = _objectWithoutProperties(_ref, _excluded);
  var Wrapper = removePortal ? React.Fragment : PopoverPrimitive.Portal;
  return /*#__PURE__*/_jsx(Wrapper, {
    children: /*#__PURE__*/_jsx(PopoverPrimitive.Content, _objectSpread({
      ref: ref,
      align: align,
      sideOffset: sideOffset,
      className: cn('tw-z-[16000010] tw-rounded tw-outline-none data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=open]:tw-fade-in-0 data-[state=closed]:tw-zoom-out-95 data-[state=open]:tw-zoom-in-95 data-[side=bottom]:tw-slide-in-from-top-2 data-[side=left]:tw-slide-in-from-right-2 data-[side=right]:tw-slide-in-from-left-2 data-[side=top]:tw-slide-in-from-bottom-2 tw-m-1', 'tw-bg-neutral-light-100 dark:tw-bg-elevation-dark-04 dark:tw-text-neutral-light-100', 'tw-shadow-03 dark:tw-shadow-none', !removePadding && 'tw-px-2 tw-py-2.4', className)
    }, props))
  });
});
PopperContent.displayName = PopoverPrimitive.Content.displayName;
export { Popper, PopperTrigger, PopperAnchor, PopperContent, PopperClose };